<template>
    <div class="wrapper">
      <div class="invite-list columns is-multiline is-gapless">
        <b-field v-for="(count, index) in inputCount"
                 :message="{ 'These addresses are duplicates': duplicateIndex[index],
                    'This is not a valid email': validationErrors.has('email-' + index) }"
                 :type="{'is-warning': duplicateIndex[index], 'is-danger': validationErrors.has('email-' + index) }"
                 :key="count"
                 class="column is-one-third">
          <b-input v-model.trim="emailList[index]"
                   v-validate="{'email': true }"
                   :name="'email-' + index"
                   :data-vv-name="'email-' + index"
                   data-vv-validate-on="blur"
                   type="email"
                   autocomplete="off"
                   icon="at"></b-input>
        </b-field>
      </div>
    </div>
</template>

<script>
export default {
  name: 'InviteToCompany',
  data() {
    return {
      emailList: []
    }
  },

  computed: {
    inputCount() {
      // count the number of non-empty emails that are in the array
      return this.emailList.filter((email) => email).length + 1
    },
    duplicateIndex() {
      // filter filter out empty values...
      /// then find any duplicate email strings in the array
      return this.emailList
        .filter((email) => email)
        .map((email1) => this.emailList.filter((email2) => email1 === email2).length > 1)
    },
    hasDuplicates() {
      return this.duplicateIndex.every((flag) => flag)
    },
    needsSmashing() {
      const lastEntry = this.emailList[this.emailList.length - 1]
      return lastEntry.includes(',')
    }
  },

  methods: {
    breakItUp() {
      const lastEntry = this.emailList.pop()
      const split = lastEntry.split(',')
      this.emailList = this.emailList.concat(split)
    }
  },

  watch: {
    emailList() {
      if (this.needsSmashing) {
        this.breakItUp()
      } else {
        this.$emit('input', this.emailList)
      }
    }
  }
}
</script>

<style scoped>
.wrapper {
  padding: 8px;
}

.invite-list {
  overflow: auto;
}

.notify-col {
  display: flex;
  align-items: center;
}
</style>
